<template>
   <Forms ref="frmGroup"
      :title="'PESQUISAR DE SOLICITAÇÕES'"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      :ShowFooterImbo="true"
      v-on:Search="Search">
      <div class="heigth-search">

        <div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" style="width: 100%;">
          <label class="label-search">Situação:</label>
          <select v-model="form.situacao.value" class="form-control">
              <option :value="null">Selecione</option>
              <option v-for="data in dataStatusDespesa" :key="data.value" :value="data.value">{{data.text}}</option>
          </select>
        </div>

        <label class="label-search">Funcionário:</label>
        <autocomplete-z ref="favorecidoTypeahead"
            placeholder="Digite o nome do Funcionário"
            iconClass="fas fa-id-badge"
            :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
            :debounceLength="3"
            :formField="form.funcionarioId"
            :returnCallback="true"
            v-on:search="onSearchFavorecido"
            v-on:changeCode="onChangeCodeFavorecido" />

        <label class="label-search">Coordenador:</label>
        <autocomplete-z ref="responsavelTypeahead"
                placeholder="Digite o nome do Responsável"
                iconClass="fas fa-users"
                :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                :debounceLength="3"
                :formField="form.coordenadorId"
                v-on:search="onSearchResponsavel"
                v-on:changeCode="onChangeCodeResponsavel" />

        <label  class="label-search">Obra:</label>
        <autocomplete-z ref="obraRHTypeahead"
            placeholder="Digite o nome da Obra"
            type="text"
            iconClass="fas fa-hard-hat"
            :serializer="(obra) => obra.referencia + ' - ' + obra.localizacao"
            :debounceLength="2"
            :formField="form.obraid"
            v-on:search="onSearchObra"
            v-on:changeCode="onChangeCodeObra"/>

        <div v-if="hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)" style="width: 100%;">
                <label class="label-search">Lote</label>
                <b-input v-model="form.lote" placeholder="Insira o Número do Lote" />
        </div>

        <!-- Filtro Empresa oculto (2026-06-19): despesas sao aprovadas por empresa, busca por empresa desnecessaria -->
        <div v-if="false" style="width: 100%;">
          <label  class="label-search">Empresa:</label>
          <autocomplete-z ref="empresaTypeahead"
              placeholder="Digite o nome da Empresa"
              type="text"
              iconClass="fa fa-university"
              :serializer="(empresa) => empresa.codigoZ + ' - ' + empresa.nome"
              :debounceLength="2"
              :formField="form.empresa"
              v-on:search="onSearchEmpresa"
              v-on:changeCode="onChangeCodeEmpresa"/>
        </div>
      </div>
   </Forms>
</template>

<script>
import searchmiscellaneousreimbursement from './searchmiscellaneousreimbursement'
export default searchmiscellaneousreimbursement
</script>

<style scoped>
.entredatas{
  margin: 0.25rem 0 0.25rem !important;
}

.datas{
  width: 95%;
}

.form-control{
  width:100%;
}

.d-flex .justify-content-between .align-items-center{
  width:100%;
}

/* .heigth-search{
    height: 50vh;
} */
.label-search{
  margin-top: 25px;
  font-weight: bold;
  line-height: 2px;
}

@media(min-width:1920px){
.datas{
  width: 100%;
}
}

</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/searchmiscellaneousreimbursement/searchmiscellaneousreimbursement.vue